    import React, { useEffect, useState } from 'react'
    import axios from "axios"
    import { Link, useNavigate } from "react-router-dom"
    import Footer from './footer'
    import "./style/Homes.css"
    import Nav from "./Nav"
    import Subfooter from './sub-footer'
import Adhero from './Adhero'
import TopRatedProducts from './TopRatedProducts'
    export default function Home() {
        const api = "https://mkbackend-production.up.railway.app"
        const navigate = useNavigate()
        const [allShops, setAllShops] = useState([])
        const [search, setSearch] = useState("")
        const [cart, setCart] = useState(() => {
            const saved = localStorage.getItem("cart")
            return saved ? JSON.parse(saved) : []
        })
        const [products, setProducts] = useState([]);
        const handleSearch = async (e) => {
    const value = e.target.value;
    setSearch(value);

    if (!value.trim()) {
        fetchData();
        setProducts([]);
        return;
    }

    const res = await axios.get(`${api}/search?q=${value}`);

    setAllShops(res.data.shops);
    setProducts(res.data.products);
};



        const fetchData = async () => {
            try {
                const res = await axios.get(`${api}/shops`)
                setAllShops(res.data.shops)
            } catch (error) {
                console.error(error)
            }
        }

        useEffect(() => {
            fetchData()
        }, [])

        const addToCart = (item) => {
            setCart((prevCart) => {
                const updated = [...prevCart, item]
                localStorage.setItem("cart", JSON.stringify(updated))
                return updated
            })
        }

        // Navigate to shop products with shop ID
        const handleShopClick = (shopSlug, shopEmail) => {
            // Store shop email for later use
            localStorage.setItem(`shop-email-${shopSlug}`, shopEmail)
            navigate(`/${shopSlug}`)
        }

        return (
            <div className='home'>
                <Nav/>
                <Adhero />    
                {/* <input 
                    type="text" 
                    placeholder="Search shops..." 
                    onChange={(e) => setSearch(e.target.value)} 
                    value={search} 
                /> */}
                <input
    type="text"
    placeholder="Search products or shops..."
    value={search}
    onChange={handleSearch}
/>
                 {search.trim() === "" && (
    <>
        <h1 className='pro-shops'>⭐ Top Rated Products</h1>
        <TopRatedProducts />
    </>
)}
   {products.map((product) => {
    const shopSlug = product.owner?.slug || product.shopSlug 
    const productSlug = product.slug
    return(
    <div
        key={product._id}
        className="shop"
        onClick={() =>
            navigate(`/product/${shopSlug}/${productSlug}`)
        }
    >
        <img src={product.image} alt={product.name} />
        <h2>{product.name}</h2>
        <h3>Rs: {product.price}</h3>
    </div>
)})}
   {allShops.length > 0 && (
    <>
        <h1 className="pro-shops">Shops</h1>

        <div className="shops">
            {allShops.map((shop) => (
                <div
                    key={shop._id}
                    className="shop"
                    onClick={() => handleShopClick(shop.slug, shop.email)}
                >
                    <img src={shop.image} alt={shop.shopName} />
                    <h2>{shop.shopName}</h2>
                </div>
            ))}
        </div>
    </>
)}
              <div className="ai-button-container">
    <Link
        to="/ai-dashboard" 
        className="ai-button ai-button-tooltip"
        aria-label="Open AI Assistant"
    >
        <span className="ai-icon">🤖</span>
        <span className="ai-text">AI Assistant</span>
        <span className="ai-badge">NEW</span>
    </Link>
</div>
                    <div className="subFooter">
                        <Subfooter />
                    </div>
                <div className="footer">
                    <Footer />
                </div>
            </div>
        )
    }